import { useReducer, useEffect } from 'react';

const initialState = { tables: [], past: [], future: [], loading: false };

function reducer(state, action) {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.value };

    case 'LOAD_TABLES':
      return { ...initialState, tables: action.tables };

    case 'MOVE_TABLE': {
      const before = state.tables;
      const tables = state.tables.map(t =>
        String(t.id) === String(action.id)
          ? { ...t, positionX: action.x, positionY: action.y }
          : t
      );
      return {
        ...state,
        tables,
        past:   [...state.past, before],
        future: [],
      };
    }

    case 'UNDO':
      if (!state.past.length) return state;
      return {
        ...state,
        tables:  state.past[state.past.length - 1],
        past:    state.past.slice(0, -1),
        future:  [state.tables, ...state.future],
      };

    case 'REDO':
      if (!state.future.length) return state;
      return {
        ...state,
        tables:  state.future[0],
        past:    [...state.past, state.tables],
        future:  state.future.slice(1),
      };

    default:
      return state;
  }
}

export function useTableHistory() {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const handler = (e) => {
      if (e.ctrlKey && e.key === 'z') dispatch({ type: 'UNDO' });
      if (e.ctrlKey && e.key === 'y') dispatch({ type: 'REDO' });
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return {
    tables:  state.tables,
    loading: state.loading,
    canUndo: state.past.length > 0,
    canRedo: state.future.length > 0,
    dispatch,
  };
}
